'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function Quote(p) {
    return _react2['default'].createElement(
        'div',
        { className: 'seo-cloud-integrations__quote-container' },
        _react2['default'].createElement(
            'p',
            { className: 'quote' },
            '\'',
            p.quote,
            '\''
        ),
        _react2['default'].createElement(
            'p',
            { className: 'quote-name' },
            p.name
        ),
        _react2['default'].createElement(
            'p',
            { className: 'quote-title' },
            p.title
        )
    );
}

module.exports = Quote;


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/common/quote-section.jsx
 ** module id = 1246
 ** module chunks = 0
 **/